import React from 'react'

const VermouthLine = ({ name, price }) => {
      
    return (
        <div className="vermut-item">
          <span className="vermut-name">{name}</span>
          <span className="dots" />
          <span className="vermut-price">{price}</span>
        </div>
      );
    };
    

export default VermouthLine